/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type CreateXrayTestDtoFollowup =
  | (typeof CreateXrayTestDtoFollowup)[keyof typeof CreateXrayTestDtoFollowup]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateXrayTestDtoFollowup = {
  NONE: 'NONE',
  SPUTUM_TEST: 'SPUTUM_TEST',
  MRI: 'MRI',
  CT_SCAN: 'CT_SCAN',
} as const;
